export const PurchaseGtagEvent = (gtagTracking: boolean, reservationDetails: any,
                                  vehicle: any, sendGaEvent: Function, reservationLength: any,
                                  price: number, reservationId: number ) => {

    if (!reservationDetails || !vehicle || !reservationLength || !reservationId || !gtagTracking) return;

    // add products
    let tax;
    let kmPrice = 0;
    let insurancePrice = 0;
    let hookPrice = 0;
    let windshieldPrice = 0;
    let tireInsurancePrice = 0;
    let cancellationInsurancePrice = 0;
    let co2CompensationPrice = 0;
    let additionalDriverPrice = 0;
    let exportPrice = 0;
    let paymentPrice = 0;
    let kmName = '';

    // add vehicle product - total price includes 100km
    let itemName = vehicle.vehicleModelData.manufacturer + ' ' + vehicle.vehicleModelData.name;
    if (vehicle.vehicleModelData.dimensions.trunkVolume !== 0) {
        itemName = itemName + ' ' + vehicle.vehicleModelData.dimensions.trunkVolume + ' m3';
    }

    let customerType = 'consumer';
    if (reservationDetails.companyVatNumber) {
        customerType = 'company';
    }

    let rentalOrigin = '24rent'
    if (reservationDetails.oneway) {
        rentalOrigin = 'OneWay'
    }

    let vehicleType = 'car'
    if (vehicle.vehicleModelData.type == 'van') {
        vehicleType = 'van'
    }
    if ((vehicle.tagCloud).indexOf('minibussi') > -1) {
        vehicleType = 'bus';
    }

    let items = [];
    let itemIndex = 0;
    let itemObject = {
        item_id: String(reservationId),
        item_name: itemName,
        index: Number(itemIndex),
        item_category: vehicleType,
        item_category2: customerType,
        item_category3: rentalOrigin,
        price: Number(price),
        quantity: 1
    }
    items.push(itemObject);
    itemIndex ++;

    // add km product if not default 100km
    if (reservationDetails.km !== 100) {
        if (reservationDetails.km === 0) {
            kmName = 'unlimitedKilometers';
            if (vehicle.pricingData.coupon) {
                kmPrice = vehicle.pricingData.withCoupon.unlimitedKilometers / 100 * reservationLength;
            } else {
                kmPrice = vehicle.pricingData.base.unlimitedKilometers / 100 * reservationLength;
            }
        } else {
            kmName = reservationDetails.km + 'km';
            if (vehicle.pricingData.coupon) {
                kmPrice = vehicle.pricingData.withCoupon.pricePerKilometer / 100 * ((reservationDetails.km - vehicle.pricingData.withCoupon.freeKilometers - 100) < 0 ? 0 : (reservationDetails.km - vehicle.pricingData.withCoupon.freeKilometers - 100)) * reservationLength;
            } else {
                kmPrice = vehicle.pricingData.base.pricePerKilometer / 100 * (reservationDetails.km - 100) * reservationLength;
            }
        }
        itemObject = {
            item_id: String(kmName),
            item_name: String(kmName),
            index: Number(itemIndex),
            price: Number(kmPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
            }
        items.push(itemObject);
        itemIndex ++;
    }
    // add insurance product if not default
    let insurance_array = reservationDetails.insurance.split(',');
    if (insurance_array.includes('1028')) {
        if (vehicle.pricingData.coupon) {
            insurancePrice = vehicle.pricingData.withCoupon.lowDeductible / 100 * reservationLength;
        } else {
            insurancePrice = vehicle.pricingData.base.lowDeductible / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("lowDeductable"),
            item_name: String("lowDeductable"),
            index: Number(itemIndex),
            price: Number(insurancePrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    if (insurance_array.includes('1053')) {
        if (vehicle.pricingData.coupon) {
            insurancePrice = vehicle.pricingData.withCoupon.midDeductible / 100 * reservationLength;
        } else {
            insurancePrice = vehicle.pricingData.base.midDeductible / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("lowDeductable"),
            item_name: String("lowDeductable"),
            index: Number(itemIndex),
            price: Number(insurancePrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }

    // add hook product if not default
    if (insurance_array.includes('1027') || reservationDetails.other === 1027) {
        if (vehicle.pricingData.coupon) {
            hookPrice = vehicle.pricingData.withCoupon.towHitch / 100 * reservationLength;
        } else {
            hookPrice = vehicle.pricingData.base.towHitch / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("towHitch"),
            item_name: String("towHitch"),
            index: Number(itemIndex),
            price: Number(hookPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add windshield product if not default
    if (insurance_array.includes('1026')) {
        if (vehicle.pricingData.coupon) {
            windshieldPrice = vehicle.pricingData.withCoupon.windshieldInsurance / 100 * reservationLength;
        } else {
            windshieldPrice = vehicle.pricingData.base.windshieldInsurance / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("windshieldInsurance"),
            item_name: String("windshieldInsurance"),
            index: Number(itemIndex),
            price: Number(windshieldPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add tireInsurance product if not default
    if (insurance_array.includes('1038')) {
        if (vehicle.pricingData.coupon) {
            tireInsurancePrice = vehicle.pricingData.withCoupon.tireInsurance / 100 * reservationLength;
        } else {
            tireInsurancePrice = vehicle.pricingData.base.tireInsurance / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("tireInsurance"),
            item_name: String("tireInsurance"),
            index: Number(itemIndex),
            price: Number(tireInsurancePrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add cancellationInsurance product if not default
    if (insurance_array.includes('1040')) {
        if (vehicle.pricingData.coupon) {
            cancellationInsurancePrice = vehicle.pricingData.withCoupon.cancellationInsurance / 100 * reservationLength;
        } else {
            cancellationInsurancePrice = vehicle.pricingData.base.cancellationInsurance / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("cancellationInsurance"),
            item_name: String("cancellationInsurance"),
            index: Number(itemIndex),
            price: Number(cancellationInsurancePrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add additionalDriver product if not default
    if (insurance_array.includes('1041')) {
        if (vehicle.pricingData.coupon) {
            additionalDriverPrice = vehicle.pricingData.withCoupon.additionalDriver / 100 * reservationLength;
        } else {
            additionalDriverPrice = vehicle.pricingData.base.additionalDriver / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("additionalDriver"),
            item_name: String("additionalDriver"),
            index: Number(itemIndex),
            price: Number(additionalDriverPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add export product if not default
    if (reservationDetails.export) {
        if (vehicle.pricingData.coupon) {
            exportPrice = vehicle.pricingData.withCoupon.export / 100 * reservationLength;
        } else {
            exportPrice = vehicle.pricingData.base.export / 100 * reservationLength;
        }
        itemObject =
        {
            item_id: String("export"),
            item_name: String("export"),
            index: Number(itemIndex),
            price: Number(exportPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add co2compensation product if not default
    if (insurance_array.includes('1047')) {
        co2CompensationPrice = vehicle.pricingData.base.hundredTwentyFiveGramsCOTwo / 100 * reservationLength;
        itemObject =
        {
            item_id: String("co2compansation"),
            item_name: String("co2compansation"),
            index: Number(itemIndex),
            price: Number(co2CompensationPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add co2compensation product if not default
    if (insurance_array.includes('1048')) {
        co2CompensationPrice = vehicle.pricingData.base.fiveHundredGramsCOTwo / 100 * reservationLength;
        itemObject =
        {
            item_id: String("co2compansation"),
            item_name: String("co2compansation"),
            index: Number(itemIndex),
            price: Number(co2CompensationPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add co2compensation product if not default
    if (insurance_array.includes('1049')) {
        co2CompensationPrice = vehicle.pricingData.base.sevenHundredGramsCOTwo / 100 * reservationLength;
        itemObject =
        {
            item_id: String("co2compansation"),
            item_name: String("co2compansation"),
            index: Number(itemIndex),
            price: Number(co2CompensationPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    // add billing product
    if (reservationDetails.paymentMethod === 2) {
        paymentPrice = 5;
        itemObject =
        {
            item_id: String("billing"),
            item_name: String("billing"),
            index: Number(itemIndex),
            price: Number(paymentPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    if (reservationDetails.paymentMethod === 3) {
        paymentPrice = 0;
        itemObject =
        {
            item_id: String("quota"),
            item_name: String("quota"),
            index: Number(itemIndex),
            price: Number(paymentPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }
    if (reservationDetails.paymentMethod === 6) {
        paymentPrice = 0;
        itemObject =
        {
            item_id: String("free"),
            item_name: String("free"),
            index: Number(itemIndex),
            price: Number(paymentPrice.toFixed(2)),
            quantity: Number(1),
            item_category: '',
            item_category2: '',
            item_category3: ''
        }
        items.push(itemObject);
        itemIndex ++;
    }

    if (price === 0) {
        tax = 0;
    } else {
        tax = (price || 0) - ((price || 0) * 100 / 124);
    }

    sendGaEvent("sendpurchase", "purchase", {
        transaction_id: String(reservationId),
        value: Number(price),
        tax: Number(tax.toFixed(2)),
        currency: "EUR",
        items: items
    });
}